<script>
  export let message = "";
</script>

<div class="error px-4 pb-2 pt-3 bg-red-500 text-white rounded-b -mt-2 mb-3">
  {message}
</div>